import { atom } from 'jotai';

/**
 * Whether listing→detail view transitions are enabled (the
 * `details_transition_2026` CMS flag). Set once at the app root (RootPage
 * Body, like `_displayModeAtom`); tiles and the detail hero read it to decide
 * whether to opt navigations into a view transition, claim the shared hero
 * snapshot name and request the overlay presentation.
 *
 * Defaults off, so surfaces that never set it (Business Manager, unit tests)
 * keep plain navigations.
 */
export const uiContextAtomViewTransitionsEnabled = atom(false);
